"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Animations = void 0;
const aos_1 = __importDefault(require("aos"));
class Animations {
    static init() {
        aos_1.default.init({
            once: true,
            offset: 250,
            duration: 500,
            disable: function () {
                const maxWidth = 768;
                return window.innerWidth < maxWidth;
            },
        });
    }
}
exports.Animations = Animations;
